import { UPLOAD_IMAGES_BEGIN, UPLOAD_IMAGES_SUCCESS, UPLOAD_IMAGES_FAILURE } from './constants'

import { BFFAgent } from '../../../common/BFFAgent'

export function uploadFiles({ newFiles = [], deletedFileIds = [], reorderedFiles = [], associationId = '' }) {
    return async dispatch => {
        dispatch({
            type: UPLOAD_IMAGES_BEGIN
        })

        try {
            if (newFiles.length) {
                const uploadedFiles = await BFFAgent.Files.bulkUploadFiles(
                    newFiles.map(newFile => newFile.file),
                    newFiles.map(newFile => newFile.id)
                )
                await BFFAgent.Files.bulkInsertFileAssociations(
                    uploadedFiles.data.map(fileResponse => fileResponse.data),
                    'PLAN',
                    associationId
                )
            }

            if (deletedFileIds.length) {
                await BFFAgent.Files.deleteFileAssociationsByEntity(deletedFileIds, associationId, 'PLAN')
                await BFFAgent.Files.deleteFilesById(deletedFileIds)
            }

            if (reorderedFiles.length) {
                await BFFAgent.Files.updateFileAssociationsOrder(reorderedFiles, associationId, 'PLAN')
            }
            dispatch({
                type: UPLOAD_IMAGES_SUCCESS
            })
        } catch {
            dispatch({
                type: UPLOAD_IMAGES_FAILURE
            })
            throw new Error('No se pudo subir el archivo. Por favor, inténtalo de nuevo.')
        }
    }
}

export function reducer(state, action) {
    switch (action.type) {
        case UPLOAD_IMAGES_BEGIN:
            return {
                ...state,
                locationsPending: true
            }
        case UPLOAD_IMAGES_SUCCESS:
            return {
                ...state,
                locationsPending: false
            }
        case UPLOAD_IMAGES_FAILURE:
            return {
                ...state,
                locationsError: true,
                locationsPending: false
            }

        default:
            return state
    }
}
